import React from "react";
import { Box, styled, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";

const OrderCard = ({ orderId, deliveryDate, label, slot, deliveryMode }) => {
  return (
    <Box>
      {/* <Typography
        variant="h6"
        fontWeight={500}
        sx={{ fontSize: "18px", color: "var(--neutral-black)", mb: 2 }}
      >
        Order Details
      </Typography> */}
      <Box
        sx={{
          background:
            "radial-gradient(circle at top left, rgba(255,247,231,0.96) 0%, rgba(255,255,255,0.98) 48%, rgba(255,250,242,0.95) 100%)",
          boxShadow: "0 12px 28px rgba(173, 132, 61, 0.08)",
          display: "inline-block",
          borderRadius: "18px",
          border: "1px solid rgba(183, 124, 10, 0.24)",
          padding: "24px 20px",
          width: "100%",
        }}
      >
        <Grid container spacing={4}>
          <Wrapper size={{ xs: 6, md: 3 }}>
            <LabelText>Order ID</LabelText>
            <ValueText>{`#${orderId}`}</ValueText>
          </Wrapper>
          <Wrapper size={{ xs: 6, md: 3 }}>
            <LabelText>{label}</LabelText>
            <ValueText>{deliveryDate}</ValueText>
          </Wrapper>
          <Wrapper size={{ xs: 6, md: 3 }}>
            <LabelText>Mode</LabelText>
            <ValueText>{deliveryMode}</ValueText>
          </Wrapper>
          <Wrapper size={{ xs: 6, md: 3 }}>
            <LabelText>Slot</LabelText>
            <ValueText>{slot}</ValueText>
          </Wrapper>
        </Grid>
      </Box>
    </Box>
  );
};
const Wrapper = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  justifyContent: "space-between",
}));
const LabelText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 12,
  lineHeight: "133%",
  color: "#866635",
}));
const ValueText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 13,
  lineHeight: "150%",
  color: "#2C2418",
}));
export default OrderCard;
